function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M35.407 10.952v2.13s-2.123.09-2.123 0c0-1.065 1.062-5.327-3.315-5.327-4.117 0-4.117 2.131-4.224 5.328H10.988c1.061-4.262-2.124-5.328-3.186-5.328-1.061 0-5.308 0-4.234 5.328H.399c0-1.84-.304-5.655 1.057-7.46.214-.284 5.22-.883 5.28-1.065C7.792 1.362 8.848.296 9.904.296h11.617l5.28 5.328s5.433 0 7.545 2.131c1.061 1.066 1.061 2.131 1.061 3.197zM8.864 4.558c0 .8 1.062 1.066 1.062 1.066h5.23V1.362h-5.23S8.864 3.937 8.864 4.558zm8.494-3.196v4.262h7.432l-4.247-4.262h-3.185z"
}), React.createElement("path", {
  d: "M29.506 14.587a3.066 3.066 0 0 1-3.062-3.071 3.066 3.066 0 0 1 3.062-3.072 3.066 3.066 0 0 1 3.062 3.072 3.066 3.066 0 0 1-3.062 3.07zm0-.815c1.24 0 2.247-1.01 2.247-2.256a2.252 2.252 0 0 0-2.247-2.257 2.252 2.252 0 0 0-2.247 2.257 2.252 2.252 0 0 0 2.247 2.256zM7.506 14.587a3.066 3.066 0 0 1-3.062-3.071 3.066 3.066 0 0 1 3.062-3.072 3.066 3.066 0 0 1 3.062 3.072 3.066 3.066 0 0 1-3.062 3.07zm0-.815c1.24 0 2.247-1.01 2.247-2.256a2.252 2.252 0 0 0-2.247-2.257 2.252 2.252 0 0 0-2.247 2.257 2.252 2.252 0 0 0 2.247 2.256z"
}));

var SvgVehicleCar = function SvgVehicleCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 15,
    viewBox: "0 0 36 15",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-car.cc5fc4f5.svg";
export { ForwardRef as ReactComponent };